<script lang="ts">
  export let authorName: string;
  export let authorTitle: string | undefined = undefined; // e.g. CTO of Vaporware Inc.
</script>

<div
  class="flex flex-col justify-center border rounded-lg py-5 px-6 sm:mx-16 sm:my-12 my-8 border-white/20"
>
  <div>
    <div class="marketing-h4 text-zinc-200">
      “<slot />”
    </div>
    <div class="mt-6 text-sm flex flex-col">
      {#if authorTitle}
        <div class="font-medium">
          <span class="font-medium">— {authorName},</span>
          <span class="text-white/60">{authorTitle}</span>
        </div>
      {:else}
        <div class="font-medium">— {authorName}</div>
      {/if}
    </div>
  </div>
</div>
